export function buildTelegramLoginData(user) {
  const params = new URLSearchParams();
  Object.keys(user || {})
    .sort()
    .forEach((key) => {
      const value = user[key];
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  return params.toString();
}

// --- Telegram OIDC login (PKCE) ---
// Заменяет устаревший iframe Login Widget (deprecated Telegram'ом).

const PKCE_VERIFIER_KEY = 'tg_oidc_code_verifier';

function base64UrlEncode(bytes) {
  let str = '';
  bytes.forEach((b) => { str += String.fromCharCode(b); });
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function sha256(input) {
  const data = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return new Uint8Array(digest);
}

function randomString(length = 64) {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return base64UrlEncode(bytes);
}

export async function startTelegramOidcLogin({ clientId, redirectUri }) {
  const codeVerifier = randomString(64);
  const codeChallenge = base64UrlEncode(await sha256(codeVerifier));
  const state = randomString(16);

  sessionStorage.setItem(PKCE_VERIFIER_KEY, codeVerifier);
  sessionStorage.setItem('tg_oidc_state', state);

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid profile',
    state,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  });

  window.location.href = `https://oauth.telegram.org/auth?${params.toString()}`;
}

export function consumeTelegramOidcRedirect() {
  const url = new URL(window.location.href);
  const code = url.searchParams.get('code');
  const state = url.searchParams.get('state');
  if (!code) return null;

  const expectedState = sessionStorage.getItem('tg_oidc_state');
  const codeVerifier = sessionStorage.getItem(PKCE_VERIFIER_KEY);
  sessionStorage.removeItem('tg_oidc_state');
  sessionStorage.removeItem(PKCE_VERIFIER_KEY);

  // Убираем query-параметры из адресной строки, чтобы code не остался в истории/при рефреше
  window.history.replaceState({}, document.title, url.pathname);

  if (!codeVerifier || state !== expectedState) return null;
  return { code, codeVerifier };
}

export function getAuthHeaders(auth) {
  if (!auth) return {};
  if (auth.type === 'webapp' && auth.value) {
    return { 'X-Telegram-Init-Data': auth.value };
  }
  if (auth.type === 'login' && auth.value) {
    return { 'X-Telegram-Login-Data': auth.value };
  }
  return {};
}

export function withAuthHeaders(auth, extra = {}) {
  return { ...extra, ...getAuthHeaders(auth) };
}
